import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RemindersStorage {
    remindersRefresher = new BehaviorSubject<boolean>(false);
    remindersList = new BehaviorSubject([]);
    modalOpened = new BehaviorSubject<boolean>(false);

    constructor() { }

    setRemindersRefresher(value: boolean): void {
        this.remindersRefresher.next(value);
    }

    listenRemindersRefresher(): Observable<boolean> {
        return this.remindersRefresher.asObservable();
    }

    setReminders(remindersList: any[]): void {
        this.remindersList.next(remindersList);
    }

    getReminders(): Observable<any[]> {
        return this.remindersList.asObservable();
    }

    openReminderModal(value: boolean) {
        this.modalOpened.next(value);
    }

    listenReminderModalOpenedRefresher(): Observable<boolean> {
        return this.modalOpened.asObservable();
    }
}
